import { CMREventTypes } from '@shared/src/enums/CMREventTypes';
import { RoutePartCMRDto } from './RoutePartCMRDto';

/**
 * Petició per afegir un event a l'eCMR. El routePartCMRId només serveix perquè el backend sàpiga de quin eCMR es tracta
 */
export class SaveECMREventDto {
    public routePartCMRId: number;
    public event: string;
    public cmrEventType: CMREventTypes;

    public static build(routePartCMRId: number, event: string, eventType: CMREventTypes): SaveECMREventDto {
        const data: SaveECMREventDto = new SaveECMREventDto();
        data.routePartCMRId = routePartCMRId;
        data.event = event;
        data.cmrEventType = eventType;
        return data;
    }

    public static buildByRoutePartCMR(routePartCMR: RoutePartCMRDto, event: string, eventType: CMREventTypes): SaveECMREventDto {
        if (routePartCMR == null)
            return null;
        return SaveECMREventDto.build(routePartCMR.routePartCMRId, event, eventType);
    }
}
